import { ThemeProvider } from 'styled-components';
import Script from 'next/script';
import Head from 'next/head';
import { GlobalStyles, theme } from '~/styles';
import type { AppProps } from 'next/app';
import { AppetizerProvider } from '@getinapp/appetizer';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { HasFooterProvider } from '~/contexts/useHasFooter';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import i18n from '@getin-widgets/i18n';
import { initReactI18next } from 'react-i18next';
import { useState } from 'react';

i18n.use(initReactI18next).init();

function MyApp({ Component, pageProps }: AppProps) {
  const [queryClient] = useState(() => new QueryClient());

  return (
    <AppetizerProvider>
      <Script
        async
        id="gtm"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `window.dataLayer = window.dataLayer || [];
            function gtag() { dataLayer.push(arguments);}
            gtag('set', 'cookie_flags', 'secure;samesite=none');(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-W4HZKB7');`,
        }}
      />
      <Script
        id="heap-analytics"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
              (window.heapReadyCb = window.heapReadyCb || []),
              (window.heap = window.heap || []),
              (heap.load = function(e, t) {
                (window.heap.envId = e),
                (window.heap.clientConfig = t = t || {}),
                (window.heap.clientConfig.shouldFetchServerConfig = !1);
                var a = document.createElement('script');
                (a.type = 'text/javascript'),
                (a.async = !0),
                (a.src = 'https://cdn.us.heap-api.com/config/' + e + '/heap_config.js');
                var r = document.getElementsByTagName('script')[0];
                r.parentNode.insertBefore(a, r);
                var n = ['init','startTracking','stopTracking','track','resetIdentity','identify','identifyHashed','getSessionId','getUserId','getIdentity','addUserProperties','addEventProperties','removeEventProperty','clearEventProperties','addAccountProperties','addAdapter','addTransformer','addTransformerFn','onReady','addPageviewProperties','removePageviewProperty','clearPageviewProperties','trackPageview'],
                i = function(e) {
                  return function() {
                    var t = Array.prototype.slice.call(arguments, 0);
                    window.heapReadyCb.push({ name: e, fn: function() { heap[e] && heap[e].apply(heap, t); } });
                  };
                };
                for (var p = 0; p < n.length; p++) heap[n[p]] = i(n[p]);
              });
              heap.load('${process.env.NEXT_PUBLIC_HEAP_ID}');
            `,
        }}
      />
      <Script
        async
        strategy="afterInteractive"
        src={`https://www.googletagmanager.com/gtag/js?id=GTM-W4HZKB7`}
      />
      <Head>
        <noscript>
          <iframe
            src="https://www.googletagmanager.com/ns.html?id=GTM-W4HZKB7"
            height="0"
            width="0"
            style={{ display: 'none', visibility: 'hidden' }}
          ></iframe>
        </noscript>
        <title>Get In - Acompanhe sua posição na fila</title>

        <link rel="shortcut icon" href="/img/icon-192-rounded.png" />
        <link rel="apple-touch-icon" href="/img/icon-512.png" />
        <link
          rel="preload"
          href="/fonts/MaisonNeueExt-Light.ttf"
          as="font"
          crossOrigin="anonymous"
        />
        <link
          rel="preload"
          href="/fonts/ACaslonPro-Italic.otf"
          as="font"
          crossOrigin="anonymous"
        />
        <link
          rel="preload"
          href="/fonts/MaisonNeueExt-Medium.ttf"
          as="font"
          crossOrigin="anonymous"
        />
        <link
          rel="preload"
          href="/fonts/MaisonNeueExt-Bold.ttf"
          as="font"
          crossOrigin="anonymous"
        />
      </Head>
      <QueryClientProvider client={queryClient}>
        <HasFooterProvider>
          <ThemeProvider theme={theme}>
            <GlobalStyles />
            <Component {...pageProps} />
            <ToastContainer />
          </ThemeProvider>
        </HasFooterProvider>
      </QueryClientProvider>
    </AppetizerProvider>
  );
}

export default MyApp;
